import './footer.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TripadvisorIcon from '../../images/slink/tripadvisor_bw.png';
import BookingIcon from '../../images/slink/booking.png';
import { IconButton } from '@mui/material';
import sociallink from '../../db/sociallink';
import logo from '../../assets/logo.png'

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
       <div className='footer-brand'>
        <img src={logo} height={90} alt="logo" />
         <div className="footer-brand-1">
          <h2 className="footer-logo">Heaven Upon Rice Fields</h2>
          <p className="footer-desc">
            Experience the tranquility of Sri Lanka’s natural beauty — a perfect
            getaway surrounded by lush paddy fields and gentle breezes.
          </p>
        </div>
       </div>

        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <IconButton href={sociallink.facebook} target="_blank">
              <FacebookIcon />
            </IconButton>

            <IconButton href={sociallink.whatsapp} target="_blank">
              <WhatsAppIcon />
            </IconButton>

            <IconButton href={sociallink.instagram} target="_blank">
              <InstagramIcon />
            </IconButton>

            <IconButton href={sociallink.tripadvisor} target="_blank">
              <img src={TripadvisorIcon} alt="Tripadvisor" width={30} />
            </IconButton>

            <IconButton href={sociallink.youtube} target="_blank">
              <YouTubeIcon />
            </IconButton>

            <IconButton href={sociallink.booking} target="_blank">
              <img
                src={BookingIcon}
                alt="Booking.com"
                width={20}
                style={{ filter: 'grayscale(100%)' }}
              />
            </IconButton>
          </div>
        </div>

        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>✉️ heavenuponricefields@gmail.com</p> 
          <p>📞 +94 71 2653653 / +94 76 7253653</p>
          <p>📍 5th Lane, Nuwarawewa watta, Mihinthala Road, Jaffna Junction, Anuradhapura</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2023 Heaven Upon Rice Fields — All Rights Reserved</p>
      </div>
    </footer>
  );
};
